/**
 * COPYRIGHT NOTICE
 * Copyright (c) 2020 Neue Rituale GbR
 * @author NR <code@neuerituale.com>
 */

import axios from "./axios";
import store from "../store";

function errorResponseHandler(err) {
	if (err.response) {
		store.commit ('global/setFatal', {status: err.response.status, ...err.response.data});
	}
}

// apply interceptor on response
axios.interceptors.response.use(
	response => response,
	errorResponseHandler
);


export default errorResponseHandler;
